module.exports = __webpack_public_path__ + "img/pt1.ff640886.png";